// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { DropdownFilterComponent } from '@coa/app/shared/dropdown/components/dropdown-filter/dropdown-filter.component';
import { FeatureToggleModule } from '@coa/app/shared/feature-toggle/feature-toggle.module';

@NgModule({
  declarations: [
    DropdownComponent,
    DropdownFilterComponent,
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatBadgeModule,
    TranslateModule,
    MatIconModule,
    FeatureToggleModule,
  ],
  exports: [
    DropdownComponent,
    DropdownFilterComponent,
  ],
})
export class DropdownModule {
}
